import * as React from 'react'

function SvgSoundOffButtonS(props) {
  return (
    <svg width="1em" height="1em" viewBox="0 0 38 30" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        d="M6.662 9.24h.166l.133-.099L17.895.967h0l.003-.002.01-.008.048-.033c.041-.029.102-.07.175-.115.15-.093.333-.193.503-.255a.921.921 0 01.191-.05.812.812 0 01.005.098v28.627c0 .157-.02.235-.034.271a.772.772 0 01-.264-.068 3.173 3.173 0 01-.58-.326 4.786 4.786 0 01-.256-.19l-.013-.01-.003-.002h0l-.01-.009-.012-.008L6.96 20.948l-.133-.098H1.5V9.24h5.162zM18.81.447l.005.011-.005-.01zm-.03 29.08l.007-.01c-.004.008-.007.01-.007.01z"
        fill="#333"
        stroke="#333"
      />
      <line x1={27.185} y1={11.796} x2={36.386} y2={20.997} stroke="#333" strokeWidth={2} strokeLinecap="round" />
      <line x1={26.95} y1={20.997} x2={36.152} y2={11.796} stroke="#333" strokeWidth={2} strokeLinecap="round" />
    </svg>
  )
}

export default SvgSoundOffButtonS
